import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useSessionProvider } from "../../contexts/sessionProvider";
import AuthService from "../../services/AuthService";
import ReCAPTCHA from "react-google-recaptcha";
import ProviderServices from "../../services/ProviderServices";
import Loading from "../../components/shared/Loading";
import MessageModal from "../../components/shared/MessageModal";
import Logo from "../../../assets/images/Logo_AgenteR.svg";
import Button from "../../components/shared/Button";
import "./Login.scss";
import Auth from "../../utils/Auth";
import axios from "axios";
import config, {
  KEY_RECAPTCHA_GOOGLE_WEB,
  BLOCK_FORM,
} from "../../config/index";
import environment from "../../environments/environment";
// import { LaptopWindows } from '@material-ui/icons';

function Login() {
  const [user, setUser] = useState("");
  const [modalWarning, setModalWarning] = useState(false);
  const [modalNoInternet, setModalNoInternet] = useState(false);
  const [messageErrorLogin, setMessageErrorLogin] = useState("");
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState("");
  const [recaptcha, setRecaptcha] = useState("");
  const [countIntentLogin, setCountIntentLogin] = useState(
    localStorage.getItem("intentLogin")
      ? Number(localStorage.getItem("intentLogin"))
      : 0
  );
  const [disabledFormLogin, setdisabledFormLogin] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const { from } = location.state || { from: { pathname: "/home" } };
  const { setTimer } = useSessionProvider();

  // ENRIQUE VILLÓN

  useEffect(() => {
    // verificando el numero de intentos del formulario al iniciar el componente
    blockedForm();
  });

  const handleAuthentication = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      let localObject = {};
      const loginResponse = await AuthService.login(user, password, recaptcha);

      // destructurando objetos del api validando dependiendo de su estatus
      const { token, method, auth, jwt_expiration_time } =
        loginResponse.response || loginResponse;
      // si la autorización es verdadera removerá los intentos hechos por el usuario
      if (auth) {
        localStorage.removeItem("intentLogin");
      } else {
        // aumentando y contando los intentos en el formulario

        // setCountIntentLogin(localStorage.getItem('intentLogin')? countIntentLogin+1 :Number(localStorage.getItem('intentLogin'))+1);
        console.log(countIntentLogin);
        console.log("COUNTINTENT", typeof countIntentLogin);

        const newIntent = countIntentLogin + 1;
        setCountIntentLogin(newIntent);
        localStorage.setItem("intentLogin", newIntent);
        // mostrando modal y guardando mensaje en un estado

        setModalWarning(true);

        setMessageErrorLogin(
          loginResponse.data.message ?? "Ocurrió un error, intentelo nuevamente"
        );

        // llamando a la función para bloquear formulario
        blockedForm();
        window.grecaptcha.reset();
      }
      // setGlobalAuthorizationHeader(token);
      const { roleId, id, role, name: username } = getUserFromToken(token);
      console.log(getUserFromToken(token));
      if (method === "roles") {
        localObject.username = user;
        localObject.token = token;
        localObject.roleId = user;
        localObject.roleName = "backoffice";
      } else {
        localObject.username = user;
        localObject.token = token;
        localObject.roleId = roleId;
        localObject.userId = id;
        localObject.roleName = role;
      }
      localStorage.setItem("userappret", JSON.stringify(localObject));
      if (["carrier", "RecepcionCD", "pickuppointop"].includes(role)) {
        const ubications = await ProviderServices.getUbications(id);
        if (role !== "carrier" || role !== "RecepcionCD") {
          console.log(ubications);
          if (ubications.length > 0) {
            localObject.title = ubications[0].title;
            localObject.operatorId = ubications[0].operatorId;
            localObject.pickupPointId = ubications[0].pickupPointId;
            localObject.image =
              "https://www.mercadonegro.pe/wp-content/uploads/2017/02/a5b780d43f85fc8627c96656169213ff.png";
          }
        } else {
          localObject.pickupPoints = ubications;
        }
      }
      console.log("localObject", localObject);
      localStorage.setItem("userappret", JSON.stringify(localObject));
      // setTimer(Auth.addTime(0.5)); Descomentar esto y comentar lo de abajo para probar tiempo de expiración
      setTimer(Auth.addTime(jwt_expiration_time));
      setLoading(false);
      console.log(from);
      // return role === 'admin' ? history.push('/admin/operadores-retiro') : history.push(from.pathname)

      return history.push(Auth.getRoleHomePath());
    } catch (e) {
      setLoading(false);
      return e;
    }
  };

  // Función para bloquear el formulario limite de 3 intentos
  const blockedForm = () => {
    if (localStorage.getItem("intentLogin") === "3") {
      setdisabledFormLogin(true);
      setModalWarning(true);
      // después de BLOCK_FORM tiempo el formulario se habilita y se limpia el local Storage;
      setTimeout(() => {
        setCountIntentLogin(0);
        localStorage.setItem("intentLogin", 0);
        setdisabledFormLogin(false);
        window.location.reload();
      }, BLOCK_FORM);
    }
  };

  const setGlobalAuthorizationHeader = (token) => {
    axios.interceptors.request.use(
      (config) => {
        config.headers["Authorization"] = `Bearer ${token}`;
        return config;
      },
      (error) => Promise.reject(error)
    );
  };

  const getUserFromToken = (token) => {
    if (token) {
      try {
        return JSON.parse(atob(token.split(".")[1]));
      } catch (e) {}
    }
    return null;
  };

  const handleKeyPress = (e) => {
    // no puede presionar hasta  mientras que los campos esten llenos
    if (
      e.key === "Enter" &&
      (user === !"" || password === !"" || recaptcha || disabledFormLogin)
    )
      return handleAuthentication(e);
    else return;
  };

  return (
    <div className="login-container">
      <Loading visible={loading} />
      <MessageModal
        visible={modalWarning}
        closeModal={() => setModalWarning(false)}
        message={
          disabledFormLogin
            ? messageErrorLogin +
              " Superó los limites de intento, el formulario está bloqueado por " +
              config.BLOCK_FORM / 1000 +
              " segundos"
            : messageErrorLogin
        }
        type={1}
      />
      <MessageModal
        visible={modalNoInternet}
        closeModal={() => setModalNoInternet(false)}
        message="No tiene conexión a internet"
        type={2}
      />
      <div className="login-form-container">
        <div className="login-form">
          <img src={Logo} alt="logo-ripley" className="logo-ripley" />
          <h3>Iniciar sesión</h3>
          <form onSubmit={() => {}} onKeyPress={handleKeyPress}>
            <LoginField
              type="text"
              label="Usuario"
              stateVar="user"
              value={user}
              handleChange={(value) => setUser(value)}
              disabled={disabledFormLogin}
            />
            <LoginField
              type="password"
              label="Contraseña"
              stateVar="password"
              value={password}
              handleChange={(value) => setPassword(value)}
              disabled={disabledFormLogin}
            />
            <div className="recaptcha">
              <ReCAPTCHA
                sitekey={environment.recaptcha.webKey}
                onChange={setRecaptcha}
              />
            </div>
            <div className="login-button-container">
              <Button
                text="INGRESAR"
                onClick={handleAuthentication}
                disabled={
                  user === "" ||
                  password === "" ||
                  !recaptcha ||
                  disabledFormLogin
                }
              />
            </div>
          </form>
        </div>
      </div>
      <div className="image-login-container">
        <img
          src={require("../../../assets/images/fondo-login.png")}
          alt="fondo_bckg"
          width="auto"
          height="100%"
        />
      </div>
    </div>
  );
}

const LoginField = ({ type, label, value, handleChange, disabled }) => (
  <div className="login-field">
    <label>{label}</label>
    <input
      onChange={(e) => handleChange(e.target.value)}
      value={value}
      type={type}
      disabled={disabled}
    />
  </div>
);

export default Login;
